(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (() => {
    function updateDynamicShippingThresholds() {
      const shopifyCurrency = window.Shopify?.currency;

      if (!shopifyCurrency) return;

      const currencyCode = shopifyCurrency.active || 'USD';
      const exchangeRate = Number.parseFloat(shopifyCurrency.rate || '1');

      if (!Number.isFinite(exchangeRate) || exchangeRate <= 0) return;

      const thresholdElements = document.querySelectorAll(
        '.dynamic-shipping-threshold, .dynamic-shipping-threshold-accessible'
      );

      thresholdElements.forEach((element) => {
        const baseThreshold = Number.parseFloat(
          element.dataset.baseThreshold || '150'
        );

        if (!Number.isFinite(baseThreshold)) return;

        const convertedThreshold = baseThreshold * exchangeRate;

        try {
          element.textContent = new Intl.NumberFormat(
            document.documentElement.lang || 'en',
            {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          ).format(convertedThreshold);
        } catch (error) {
          element.textContent =
            convertedThreshold.toFixed(2) + ' ' + currencyCode;
        }
      });
    }

    function initialiseDynamicShippingThresholds() {
      updateDynamicShippingThresholds();

      document.addEventListener(
        'shopify:section:load',
        updateDynamicShippingThresholds
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initialiseDynamicShippingThresholds,
        { once: true }
      );
    } else {
      initialiseDynamicShippingThresholds();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
